import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import SectionScrollIndicator from '../../components/SectionScrollIndicator';
import ProfessionalHeadshot from './components/ProfessionalHeadshot';
import ProfessionalBiography from './components/ProfessionalBiography';
import CareerTimeline from './components/CareerTimeline';
import TechnicalExpertise from './components/TechnicalExpertise';
import EducationCredentials from './components/EducationCredentials';
import CallToAction from './components/CallToAction';

const AboutProfessionalBackground = () => {
  useEffect(() => {
    document.title = 'About - Dishant Madariya | Full Stack Developer';
    
    // Scroll to top on page load
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>About - Dishant Madariya | Full Stack Developer</title>
        <meta
          name="description"
          content="Learn more about Full Stack Developer Dishant Madariya, his professional background, education, technical expertise and journey in building modern web applications."
        />
        <meta
          name="keywords"
          content="About Dishant Madariya, full stack developer biography, professional background, MERN developer, WordPress and SaaS experience"
        />
        <link rel="canonical" href="https://port-folio-three-teal.vercel.app/about" />
      </Helmet>

      <SectionScrollIndicator />
      
      {/* Main Content */}
      <main className="pt-20 pb-16">
        <div className="max-w-7xl mx-auto px-4 sm:pr-6 sm:px-6 lg:px-8">
          {/* Page Header */}
          <div className="text-center mb-12">
            <h1 className="text-4xl md:text-5xl font-bold text-text-primary mb-4">
              About Me
            </h1>
            <p className="text-base sm:text-lg md:text-xl text-text-secondary max-w-3xl mx-auto leading-relaxed">
              Senior MERN Stack Developer | Technical Consultant | Solution Architect
            </p>
          </div>

          {/* Two-Column Layout */}
          <div className="grid lg:grid-cols-3 gap-8">
            {/* Left Column - Professional Headshot */}
            <div className="lg:col-span-1 text-left">
              <div className="lg:sticky lg:top-24">
                <ProfessionalHeadshot />
              </div>
            </div>

            {/* Right Column - Main Content */}
            <div className="lg:col-span-2 space-y-8 text-left break-words whitespace-normal min-w-0">
              <ProfessionalBiography />
              <CareerTimeline />
              <TechnicalExpertise />
              <EducationCredentials />
              <CallToAction />
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default AboutProfessionalBackground;